import React from "react";
import { Draggable } from "components/drag-and-drop";
import { Brikk } from "components/Brikk";
import { SeeMoreButton } from "components/form-elements/buttons/SeeMoreButton";
import { Image } from "components/media/Image";
import { ClockHandIcon } from "assets/icons/brikks/ClockHandIcon";
import brikkPreviewSrc from "./assets/event-brikk-preview.png";

export const EventConfigurator = ({ position }) => {
  return (
    <>
      <Draggable position={position}>
        <Brikk disabled={true}>
          <Brikk.Header icon={<ClockHandIcon />} heading="eventConfiguratorBrikk" />

          <Brikk.Content center>
            <Image src={brikkPreviewSrc} />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton disabled={true} brikkNameIntl="eventConfigurator" />
          </Brikk.Button>
        </Brikk>
      </Draggable>
    </>
  );
};
